import * as backendUrls from '../constants/backendConstants';

const trustedUrls = Object.values<string>(backendUrls);

export function isSynqoUrl(url: string): boolean {
    for (const trustedUrl of trustedUrls) {
        if (url.startsWith(trustedUrl)) {
            return true;
        }
    }

    return false;
}
